import React, { forwardRef } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const NAVY = "#0f172a";
const SLATE = "#475569";
const MUTED = "#64748b";
const BORDER = "#e2e8f0";
const CRIMSON = "#A5122F";
const W = 720;
const REMARK_PLUGINS = [remarkGfm];

const md = {
  h1: ({ node, ...p }) => <h1 style={{ fontSize: 20, color: NAVY, margin: "16px 0 8px" }} {...p} />,
  h2: ({ node, ...p }) => (
    <h2 style={{ fontSize: 15, color: NAVY, margin: "14px 0 6px", borderBottom: `1px solid ${BORDER}`, paddingBottom: 3 }} {...p} />
  ),
  h3: ({ node, ...p }) => <h3 style={{ fontSize: 13, color: CRIMSON, margin: "10px 0 5px" }} {...p} />,
  p: ({ node, ...p }) => <p style={{ fontSize: 11.5, lineHeight: 1.55, color: SLATE, margin: "0 0 8px" }} {...p} />,
  ul: ({ node, ordered, ...p }) => <ul style={{ margin: "0 0 8px", paddingLeft: 18, fontSize: 11.5, color: SLATE }} {...p} />,
  ol: ({ node, ordered, ...p }) => <ol style={{ margin: "0 0 8px", paddingLeft: 18, fontSize: 11.5, color: SLATE }} {...p} />,
  li: ({ node, ...p }) => <li style={{ margin: "0 0 3px" }} {...p} />,
  strong: ({ node, ...p }) => <strong style={{ color: NAVY }} {...p} />,
};

const ConnectionsPrint = forwardRef(function ConnectionsPrint({ contacts, connections, reportMd }, ref) {
  const list = contacts || [];
  const clusters = (connections && connections.clusters) || [];

  return (
    <div aria-hidden="true" style={{ position: "absolute", width: 0, height: 0, overflow: "hidden", left: 0, top: 0 }}>
      <div ref={ref} style={{ width: W, background: "#fff", color: NAVY, fontFamily: "Arial, Helvetica, sans-serif", padding: "0 32px 32px" }}>
        <div style={{ borderBottom: `3px solid ${CRIMSON}`, paddingBottom: 12, marginBottom: 16 }}>
          <h1 style={{ margin: 0, fontSize: 22 }}>SalesTap — Connections Report</h1>
          <p style={{ margin: "4px 0 0", fontSize: 12, color: MUTED }}>
            {list.length} contacts · {clusters.length} relationship clusters
          </p>
        </div>

        {/* Contacts list */}
        <h2 style={{ fontSize: 14, margin: "0 0 6px" }}>Contacts</h2>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 10, marginBottom: 16 }}>
          <thead>
            <tr style={{ borderBottom: `2px solid ${NAVY}` }}>
              <th style={{ textAlign: "left", padding: 3 }}>Name</th>
              <th style={{ textAlign: "left", padding: 3 }}>Company</th>
              <th style={{ textAlign: "left", padding: 3 }}>Phone</th>
              <th style={{ textAlign: "left", padding: 3 }}>Email</th>
            </tr>
          </thead>
          <tbody>
            {list.slice(0, 500).map((c) => (
              <tr key={c.id} style={{ borderBottom: `1px solid ${BORDER}` }}>
                <td style={{ padding: 3 }}>{c.name}</td>
                <td style={{ padding: 3, color: SLATE }}>{c.company || "—"}</td>
                <td style={{ padding: 3, color: SLATE }}>{c.phone || "—"}</td>
                <td style={{ padding: 3, color: SLATE }}>{c.email || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Relationship map */}
        {clusters.length > 0 && (
          <div style={{ marginBottom: 16 }}>
            <h2 style={{ fontSize: 14, margin: "0 0 6px" }}>Relationship Map</h2>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {clusters.slice(0, 30).map((g) => (
                <div key={`${g.type}:${g.label}`} style={{ border: `1px solid ${BORDER}`, borderRadius: 6, padding: "6px 10px", minWidth: 160 }}>
                  <div style={{ fontSize: 10.5, fontWeight: 700, color: NAVY }}>
                    {g.label} <span style={{ color: MUTED, fontWeight: 400 }}>({g.type})</span>
                  </div>
                  <div style={{ fontSize: 9.5, color: SLATE }}>{g.count} contacts</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* AI report */}
        <div style={{ borderTop: `2px solid ${CRIMSON}`, paddingTop: 12 }}>
          {reportMd ? (
            <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={md}>{reportMd}</ReactMarkdown>
          ) : (
            <p style={{ fontSize: 11.5, color: MUTED }}>No relationship analysis generated yet.</p>
          )}
        </div>
      </div>
    </div>
  );
});

export default ConnectionsPrint;
